var EHDI = EHDI || Object.create(null);

EHDI.ColTypeEnum = {
  COL1: 0,
  COL2: 1,
  COL3: 2,
  COL4: 3,
  COL5: 4,
  COL6: 5,
  COL7: 6,
  COL8: 7,
  COL9: 8,
  COL10: 9,
};

EHDI.game = EHDI.game || Object.create(null);

EHDI.game.Collectible = function () {
  EHDI.aka.Container.call(this);
  this.init();
};

EHDI.game.Collectible.prototype = Object.create(EHDI.aka.Container.prototype);

EHDI.game.Collectible.prototype.init = function () {
  this._type;
  this._hitbox;

  this._animation;

  if (this._hitbox == undefined) {
    this._hitbox = new EHDI.game.Hitbox(30, 30, 60, 0, 0x080808);

    this.addChild(this._hitbox);
  }
};

EHDI.game.Collectible.prototype.getAnimationPath = function () {
  var pathToReturn;

  if (this._type == EHDI.ColTypeEnum.COL1) {
    pathToReturn = 'deer';
  } else if (this._colTypeEnum == EHDI.ColTypeEnum.COL2) {
    pathToReturn = 'donkey';
  } else if (this._colTypeEnum == EHDI.ColTypeEnum.COL3) {
    pathToReturn = 'gazelle';
  } else if (this._colTypeEnum == EHDI.ColTypeEnum.COL4) {
    pathToReturn = 'goat';
  } else if (this._colTypeEnum == EHDI.ColTypeEnum.COL5) {
    pathToReturn = 'goat2';
  } else if (this._colTypeEnum == EHDI.ColTypeEnum.COL6) {
    pathToReturn = 'horse';
  } else if (this._colTypeEnum == EHDI.ColTypeEnum.COL7) {
    pathToReturn = 'horse2';
  } else if (this._colTypeEnum == EHDI.ColTypeEnum.COL8) {
    pathToReturn = 'lamb';
  } else if (this._colTypeEnum == EHDI.ColTypeEnum.COL9) {
    pathToReturn = 'ram';
  } else {
    pathToReturn = 'sheep';
  }

  return pathToReturn;
}

EHDI.game.Collectible.prototype.reset = function () {
  if (this._animation != null) {
    EHDI.GetGlobalPool().animationPool.return(this._animation);

    this._animation = null;
  }
}

EHDI.game.Collectible.prototype.setup = function (colTypeEnum, xPos, yPos) {
  this._colTypeEnum = colTypeEnum;
  this._colX = xPos;
  this._colY = yPos;
  this.x = xPos;
  this.y = yPos;

  this._type = this.getAnimationPath();

  this._hitbox.update(this.x, this.y);

  if (this._animation == null) {
    this._animation = EHDI.GetGlobalPool().animationPool.get();
    this._animation.init(this.getAnimationPath());
    this._animation.changeAnimation('idle');

    this.addChild(this._animation.getDisplay());
  }
};

EHDI.game.Collectible.prototype.getRightX = function () {
  return this.x + this._hitbox._right;
};

EHDI.game.Collectible.prototype.getLeftX = function () {
  return this.x - this._hitbox._left;
};

EHDI.game.Collectible.prototype.getHitbox = function () {
  return this._hitbox;
};

EHDI.game.Collectible.prototype.getAnimation = function () {
  var animation = this._animation;

  this.removeChild(this._animation);
  this._animation = null;

  return animation;
};

EHDI.game.Collectible.prototype.getType = function () {
  return this._type;
}

EHDI.game.Collectible.prototype.update = function (currentXPos) {
  this.x = currentXPos + this._colX;
  this._hitbox.update(this.x, this.y);
};
